// Landing pages write humanteq.startTopics before the visitor opens the PWA.
// Step 2 of onboarding reads it and preselects matching topic chips.
// Unknown labels are dropped so a landing copy change cannot submit a tag
// the onboard API has never seen. (pwa-design v2.)

import { ONBOARDING_TAGS } from './onboarding.data'

export const LANDING_START_TOPICS_KEY = 'humanteq.startTopics'

const ALLOWED_TAGS = new Set<string>(ONBOARDING_TAGS)

interface LandingStartTopics {
  topics?: unknown
}

export function readLandingStartTopics(storage: Pick<Storage, 'getItem'> = localStorage): string[] {
  try {
    const raw = storage.getItem(LANDING_START_TOPICS_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as LandingStartTopics
    if (!Array.isArray(parsed?.topics)) return []

    const seen = new Set<string>()
    const selected: string[] = []
    for (const topic of parsed.topics) {
      if (typeof topic !== 'string') continue
      const label = topic.trim()
      if (!ALLOWED_TAGS.has(label) || seen.has(label)) continue
      seen.add(label)
      selected.push(label)
    }
    return selected
  } catch {
    return []
  }
}

export function clearLandingStartTopics(storage: Pick<Storage, 'removeItem'> = localStorage): void {
  try {
    storage.removeItem(LANDING_START_TOPICS_KEY)
  } catch {
    /* private mode — the key simply stays; it is re-cleared on the next funnel */
  }
}
